export const INDUSTRIES = {
  'Legal': ['McNicholas & McNicholas, LLP', 'Sheppard Mullin', 'Pearlman, Brown & Wax, LLP', 
          'Omnus Law Services, LLC', 'Donohoe Talbert LLP', 'Taylor & Ring', 
          'Soroka & Associates LLC', 'Sacks, Glazier, Franklin, Lodise, McMurtrey & Scheerer, LLP',
          'Gray, Duffy, Eisenbaum & Lee, LLP', 'Liebert Cassidy Whitmore', 'Merlin Law Group',
          'Stradley Ronon', 'The Zinn Law Firm', 'Thompson Coburn', 'Assalone Lombardi'],
  'Financial Services': ['Falcon Wealth Planning', 'BD&J', 'GCP Advisors', 'Equity Ag Financial, Inc.'],
  'Professional Services': ['Steven Weisburd']
};